import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { Eid } from 'src/app/models/eid';

@Component({
  selector: 'app-card-info',
  templateUrl: './card-info.component.html',
  styleUrls: ['./card-info.component.scss']
})
export class CardInfoComponent implements OnInit {

  @Output() card: EventEmitter<Eid> = new EventEmitter();

  constructor() { }

  ngOnInit(): void {
    window.addEventListener('message', event => {
      if (event.source === window &&
          event.data.direction &&
          event.data.direction === 'to-becare') {
            if (event.data.message !== 'no eid') {
              const info = JSON.parse(event.data.message);
              const id = new Eid();
              Object.assign(id, info);
              this.card.emit(id);
            }
      }
    });
  }

  getEID(): void {
    window.postMessage({
      direction: 'from-becare',
      message: 'Message from the page'
    }, '*');
  }
}
